import { withApiContext, withLabelsContext, withUserContext } from "context";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { Col, Row } from "react-bootstrap";
import EntityForm from "pages/Entity/Form";
import ChapterProgress from "./ChapterProgress";
import "./Form.css";
import { withRouter, Redirect } from "react-router-dom";
import { MainContainer } from "pages/Main";
import { Breadcrumb, BackLink, } from "components";
import * as config from "config";
import * as util from "services/util";
import MediaQuery from "react-responsive";
// import { PageTitle } from 'components'

class ProgressForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      courseData: this.props.location.state?.data,
    };
    this.fields = this.mkFields(props);
  }

  static propTypes = {
    entity: PropTypes.shape({
      class_id: PropTypes.string.isRequired,
      curriculum_id: PropTypes.string.isRequired,
    }),
    action: PropTypes.string.isRequired,
  };

  mkFields = (props) => {
    return {
      chapterIds: {
        init: [],
        optional: true,
      },
    };
  };

  chapterItem = (item, i) => {

    return {
      id: item.id,
      chapter: item.chapter,
      maxScore: item.max_score,
      noOfPage: item.no_of_pages,
      videoDur: item.video_duration,
      sequence: i,
      open: false,
      module: item.modules,
    };
  };

  fetch = async () => {

    const { location, ctx_user } = this.props;
    const { data, entityDatas } = location;
    const { courseData } = this.state;

    let class_id, curriculum_id, course_publish_id, course_id;

    if (data) {
      class_id = data.class_id;
      curriculum_id = data.curriculum_id;
      course_publish_id = data.course_publish_id;
      course_id = data.course_id;
    } else if (entityDatas) {
      class_id = entityDatas.class_id;
      curriculum_id = entityDatas.curriculum_id;
      course_publish_id = entityDatas.course_publish_id;
      course_id = entityDatas.course_id;
    } else if (courseData) {
      class_id = courseData.class_id;
      curriculum_id = courseData.curriculum_id;
      course_publish_id = courseData.course_publish_id;
      course_id = courseData.course_id;
    }

    if (class_id && curriculum_id && course_publish_id && course_id) {

      const { rsp } = await this.props.ctx_api.privateRequest({
        cmd: "get_trainer_course_progress_chapter",
        args: {
          classId: class_id,
          academicYearId: ctx_user.user.acadYearId,
          curriculumId: curriculum_id,
          coursePublishId: course_publish_id,
          courseId: course_id,
          traineeId: courseData ? null : 
          entityDatas ? ctx_user.user.id : data.traineeId
            ? data.traineeId.toString()
            : data.child
            ? data.child
            : ctx_user.user.dependantId,
        },
      });

      const value = [];
      rsp.forEach((s0, i) => {
        value.push(this.chapterItem(s0, i));
      });
      return {
        chapterIds: value,
      };
    }

    return null;
  };

  renderProgress = ({ ValidatedField }) => (
    <Row>
      <Col sm={12} className="chapter-progress-col">
        <ValidatedField
          type={ChapterProgress}
          name="chapterIds"
          entity={this.props.location.data || this.props.location.entityDatas || this.props.location.state?.data}
          loading={this.state.loading}
          class={this.props.location.className || this.props.location.classNames || this.state.courseData?.classname}
          label={null}
          addRedirection={this.props.location.addRedirection}
          fromTeacherAnalytics={this.props.location.state?.fromTeacherAnalytics}
          fromClassAnalytics={this.props.location.state?.fromClassAnalytics}
          reroutingData= {this.props.location.state?.reroutingData}
          activeStudents= {this.props.location.state?.activeStudents}
          totalStudents= {this.props.location.state?.totalStudents}
          
        />
      </Col>
    </Row>
  );

  renderFields = (props) => {
    return (
      <React.Fragment>{this.renderProgress(props)}</React.Fragment>
    );
  };

  getNameLabel = (props) =>
    this.props.ctx_labels.singular[props.name] || props.name;

  render = () => {
    const { ...restProps } = this.props;
    if (!this.props.location.data && !this.props.location.entityDatas && !this.state.courseData) {
      return <Redirect to="/" />;
    }
    return (
      <MainContainer>
        <EntityForm
          {...restProps}
          customHeader={
            this.props.ctx_user.user.type === 4 ? (
              <h5>{`
              ${this.props.location.data.classname
                } | ${this.props.location.data.currname
                } | ${this.props.location.data.coursename
                }
              `}</h5>
            ) :

              <h5>{`${this.props.location?.className ||
                this.props.location?.classNames ||
                this.props.location.data?.classname ||
                this.props.location.entityDatas?.classname ||
                (this.state.courseData &&
                  (this.state.courseData.classname || this.props.location.state?.classname || this.state.courseData?.standard))
                // this.props.location.className
                //   ? this.props.location.className
                //   : this.props.location.classNames ?
                //   this.props.location.classNames
                //   : this.props.location.data.classname
                } | ${this.props.ctx_user.user.type === 2
                  ? this.props.location.data?.course_publish_name ||
                  this.props.location.entityDatas?.course_publish_name ||
                  this.props.location.entityDatas?.coursepub_name ||
                  this.props.location.data?.coursepub_name
                  : (this.props.ctx_user.user.type === -1 || this.props.ctx_user.user.type === 3)
                    && this.state.courseData?.course_name
                    || this.props.location.data?.course_name || this.props.location.entityDatas?.course_publish_name
                    || this.props.location.entityDatas?.course_name

                }  
                ${this.props.location.data?.is_multi_course === 1 || this.props.location.entityDatas?.is_multi_course === 1 || this.state.courseData?.is_multi_course === 1
                  ? "|"
                  : " "}
              ${(this.props.location.data?.is_multi_course === 1 || this.props.location.entityDatas?.is_multi_course === 1 || this.state.courseData?.is_multi_course === 1)
                  ? (this.props.location.data?.coursename || this.props.location.data?.course_name || this.props.location.entityDatas?.course_name || this.props.location.entityDatas?.coursename || this.props.location.courseData?.coursename)
                  : " "
                }
              
              `}</h5>

          }
          className="progress-form"
          fields={this.fields}
          fetch={this.fetch}
          fieldsRenderer={this.renderFields}
          isTeacherForm={true}
          hideBreadcrumb
          customBreadcrumb={
            this.props.ctx_user.user.type === 2 &&
              this.props.location.data?.fromNotification ? (
              <BackLink
                onClick={() => this.props.location.alternateRedirection()}
                to={{ pathname: config.ROUTES.chat }}
              />
            ) : (
              <MediaQuery minDeviceWidth={1024}>
              <Breadcrumb
                list={
                  this.props.ctx_user.user.type === 4
                    ? [
                      {
                        title: `${this.props.ctx_labels.singular.curriculum} Progress`,
                        current: true,
                      },
                    ]
                    : this.props.ctx_user.user.type === 2
                      ? [
                        {
                          title: this.props.ctx_labels.singular.class,
                          link: config.ROUTES.class,
                        },
                        {
                          title: `${this.props.ctx_labels.singular.curriculum} Progress`,
                          current: true,
                        },
                      ]
                      : (this.props.ctx_user.user.type === 3 || this.props.ctx_user.user.type === -1)&& 
                          (this.props.location.state?.fromTeacherAnalytics || this.props.location.state?.fromClassAnalytics)
                        ? [
                            {
                              title: this.props.ctx_labels.singular.myDashboard,
                              link: this.props.location.state?.reroutingData?.goiAdmin === true
                                ? config.ROUTES.adminDashboard
                                : config.ROUTES.campusDashboard,
                              state: {
                                orgId: this.props.location.state?.reroutingData?.orgId,
                                theme: this.props.location.state?.reroutingData?.theme,
                                goiAdmin: this.props.location.state?.reroutingData?.goiAdmin
                              },
                            },
                          {
                            title: this.props.location.state?.fromTeacherAnalytics
                              ? this.props.ctx_labels.singular.teacherAnalytics
                              : this.props.location.state?.fromClassAnalytics
                                ? this.props.ctx_labels.singular.classAnalytics
                                : "",
                            link: this.props.location.state?.fromTeacherAnalytics
                              ? config.ROUTES.teacherAnalytics
                              : this.props.location.state?.fromClassAnalytics
                                ? config.ROUTES.classAnalytics
                                : "",
                            state: {
                              theme: this.props.location.state?.reroutingData?.theme,
                              trainerId: this.props.location.state?.reroutingData?.trainerId,
                              trainerName: this.props.location.state?.reroutingData?.trainerName,
                              goiAdmin: this.props.location.state?.reroutingData?.goiAdmin,
                              orgId: this.props.location.state?.reroutingData?.orgId,
                              classId: this.props.location.state?.reroutingData?.classId,
                              batchName: this.props.location.state?.reroutingData?.batchName,
                              activeStudents: this.props.location.state?.activeStudents,
                              totalStudents: this.props.location.state?.totalStudents
                            },
                          },
                          {
                            title: `${this.props.ctx_labels.singular.curriculum} Progress`,
                            current: true,
                          },
                        ]
                        :
                        [
                          {
                            title: util.capitalizeWord(
                              this.getNameLabel({
                                name: this.props.location.data || this.props.location.entityDatas || this.state.courseData
                                  ? `${this.props.ctx_labels.singular.class}`
                                  : null,
                              })
                            ),
                            onLinkClick: () => {
                              this.props.classRedirection();
                            },
                            link: this.props.location.data || this.props.location.entityDatas
                              ? config.ROUTES.class
                              : config.ROUTES.classList,
                            data: {
                              classId: this.props.location.data ? this.props.location.data.class_id : this.props.location.entityDatas.class_id,
                              className: this.props.location.className || this.props.location?.classNames || this.props.location.classData?.class_name || this.props.location.classname,
                              interaction: this.props.location.interaction,
                              fromClassPerformance: this.props.location.fromClassPerformance
                          },
                            classData: this.props.location.classData,
                        },
                          {
                            title: `${this.props.ctx_labels.singular.curriculum} Progress`,
                            current: true,
                          },
                        ]
                }
              />
              </MediaQuery>
            )
          }
        />
      </MainContainer>
    );
  };
}

export default withApiContext(
  withUserContext(withLabelsContext(withRouter(ProgressForm)))
);
